import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

function PinModal({ show, onHide, onSuccess }) {
  const [pin, setPin] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];
  
  const correctPin = '1234'; // Default PIN for demo

  useEffect(() => {
    if (show && inputRefs[0].current) {
      inputRefs[0].current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handlePinChange = (index, value) => {
    if (value.length > 1) return;
    
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);
    setError('');

    // Auto-focus next input
    if (value && index < 3) {
      inputRefs[index + 1].current.focus();
    }

    // Check if PIN is complete
    if (index === 3 && value) {
      const enteredPin = newPin.join('');
      if (enteredPin === correctPin) {
        onSuccess();
        onHide();
        setPin(['', '', '', '']);
      } else {
        setError('Falscher PIN. Versuche es erneut.');
        setPin(['', '', '', '']);
        inputRefs[0].current.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      className="pin-modal"
      backdrop="static"
    >
      <Modal.Body className="p-5 text-center">
        <h4 className="mb-4">PIN eingeben</h4>
        <p className="text-secondary mb-4">
          Bitte gib den 4-stelligen PIN ein, um fortzufahren
        </p>
        
        <div className="pin-input-container">
          {[0, 1, 2, 3].map(index => (
            <input
              key={index}
              ref={inputRefs[index]}
              type="text"
              inputMode="numeric"
              pattern="[0-9]"
              maxLength="1"
              className="pin-input"
              value={pin[index]}
              onChange={(e) => handlePinChange(index, e.target.value.replace(/\D/g, ''))}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          ))}
        </div>

        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}

        <p className="text-muted small mt-4 mb-0">
          Demo PIN: 1234
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0">
        <Button 
          variant="secondary" 
          onClick={() => {
            onHide();
            setPin(['', '', '', '']);
            setError('');
          }}
        >
          Abbrechen
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PinModal;